export default __webpack_public_path__ + "static/media/telehealth-avenir-next-demi.41381996.woff2";